<template>
<div class="viewContainer">
  <div class="gaikuang">会员概况</div>
  <div class="findtj">
    <span @click="find(0)" :style="calssName==0?'color:#F56C6C':''" class="leftbut">按日</span>
    <span @click="find(4)" :style="calssName==4?'color:#F56C6C':''" class="leftbut">按月</span>

    <span @click="findshop()" :style="isclick?'color:#F56C6C;border-color:#F56C6C':''"
      class="rightbut">{{calssName==0?"昨日":"当月"}}</span>
    <span @click="findshop1()" :style="isclick1?'color:#F56C6C;border-color:#F56C6C':''"
      class="rightbut">{{calssName==0?"近7日":"近3月"}}</span>
    <span @click="findshop2()" :style="isclick2?'color:#F56C6C;border-color:#F56C6C':''"
      class="rightbut">{{calssName==0?"近30日":"近半年"}}</span>
    <el-date-picker type="daterange" v-model="value6" @change="haldchange" v-show="calssName==0" style="margin-left:30px;width:400px"
    value-format="yyyy-MM-dd" :editable="false" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"/>
    <el-date-picker type="month" v-model="value4" v-show="calssName==4" class="porino" style="margin-left:30px"
    :editable="false" :picker-options="pickerStartDate" value-format="yyyy-MM" @change="monthchange" placeholder="选择月"/>
    <span style="margin:0 5px" v-show="calssName==4">至</span>
    <el-date-picker type="month" v-model="value5" @change="monthchange1" v-show="calssName==4" class="porino"
    value-format="yyyy-MM" :editable="false" :picker-options="pickerCloseDate" placeholder="选择月"/>
  </div>
  <div id="main" style="width: 99%;height:400px;background:#eee;border-top:1px solid #000"></div>
  <div style="margin-top:10px" class="gaikuang">渠道引流概况</div>
  <div id="pieReport" style="width: 100%;height: 500px;"></div>
  <div class="main_container">
  <div style="margin:10px 0 0 10px" class="gaikuang">入会记录</div>
  <!-- 入会记录搜索框 -->
  <el-form :inline="true" class="findform" :model="filters" style="width: 98.5%;margin-top:10px;display:flex">
    <el-form-item style="display:flex;width:100%" label="入会方式：">
      <el-select v-model="filters.buyMode" placeholder="请选择" style="background:#fff;" ref="mySelect">
        <el-option v-for="(item,index) in buyModes" :key="index" :value="item.Id" :label="item.Name"/>
      </el-select>
    </el-form-item>
    <el-form-item style="display:flex;width:100%" label="是否消费："  class="select">
      <el-select v-model="filters.statusId" placeholder="请选择" style="background:#fff;" ref="mySelect">
        <el-option v-for="(item,index) in statusoptions" :key="index" :value="item.Id" :label="item.Name"/>
      </el-select>
    </el-form-item>
    <el-form-item style="display:flex;width:100%" label="注册时间：" class="sub_chaxun">
      <el-date-picker :title="value6" v-model="value6" :editable="iseditable"
        style="cursor:pointer;width:100%" value-format="yyyy-MM-dd" type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        @change="changetime"
        end-placeholder="结束日期"/>
    </el-form-item>
    <el-form-item class="footBtn">
      <el-button type="danger" @click="onSubmit">查询</el-button>
      <el-button type="danger" @click="onExport">导出</el-button>
    </el-form-item>
  </el-form>
    <div class="table_container">
    <el-table :data="goodList" stripe border>
      <el-table-column prop="UserName" label="会员名称" align="center">
        <template scope="scope">
          <span :title="scope.row.UserName">{{scope.row.UserName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="UserPhone" label="会员手机号" align="center">
        <template scope="scope">
          <span :title="scope.row.UserPhone">{{scope.row.UserPhone}}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="Name" label="会员卡名称" align="center">
        <template scope="scope">
          <span
            :title="scope.row.Name"
            style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
          >{{scope.row.Name}}</span>
        </template>
      </el-table-column> -->
      <el-table-column prop="BuyModeName" label="入会方式" align="center">
        <template scope="scope">
          <span :title="scope.row.BuyModeName">{{scope.row.BuyModeName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Price" label="入会价格" align="center">
        <template scope="scope">
          <span :title="scope.row.Price">￥{{scope.row.Price}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="BuyTime" label="入会时间" align="center">
        <template scope="scope">
          <span :title="scope.row.BuyTime">{{scope.row.BuyTime}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="IsHaveConsumption" label="是否已消费" align="center">
        <template scope="scope">
          <span :title="scope.row.IsHaveConsumption">{{scope.row.IsHaveConsumption}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="LatestConsumptionTime" label="最近消费时间" align="center">
        <template scope="scope">
          <span :title="scope.row.LatestConsumptionTime">{{scope.row.LatestConsumptionTime}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="ConsumptionMoney" label="最近消费金额" align="center">
        <template scope="scope">
          <span :title="scope.row.ConsumptionMoney">￥{{scope.row.ConsumptionMoney}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template scope="scope">
          <span @click="endViews(scope)" class="action_container" :style="{color: scope.row.QureySymbol == 0 ? '#ccc' : '#F56C6C'}">查看消费记录</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
    :page-size="10" :current-page="pageIndex" :total="total" style="float:right;margin:10px 0;"/>
    </div>
  </div>
</div>
</template>
<script>
import { SelectVIPStatitcs, getkind, getSelectVIPSalesRecordList, getVipBuyModeStatistics } from "../../api/api";
import { debounce } from "../../utils/index";
export default {
  name: "analysis",
  components: {
    Pie: resolve => require(["../../components/echartsoptioms"], resolve)
  },
  data() {
    return {
      chart:null,
      embershipCardPrimaryKey: "", // 会员卡主键id
      userdId: "", // 会员userId
      pickerStartDate: {
        disabledDate: time => {
          let beginDateVal = this.value5;
          if (beginDateVal) {
            return (
              time.getTime() >
              new Date(beginDateVal).getTime() 
            );
          }
        }
      },
      pickerCloseDate: {
        disabledDate: time => {
          let beginDateVal = this.value4;
          if (beginDateVal) {
            return (
              time.getTime() <
              new Date(beginDateVal).getTime() - 1 * 24 * 60 * 60 * 1000
            );
          }
        }
        // disabledDate(time){
        //   return time.getTime()<new Date().getTime()
        // }
      },
      charts: "",
      opinionData: [],
      // opinionData: [
      //   {value:335, name:'商品管理'},
      //   {value:310, name:'订单管理'},
      //   {value:274, name:'促销管理'},
      //   {value:235, name:'会员卡管理'},
      //   {value:400, name:'询价管理'}
      // ],
      // opinionData: [
      //   { value: 12, name: "及格人数", itemStyle: "#1ab394" },
      //   { value: 18, name: "未及格人数", itemStyle: "#79d2c0" }
      // ],
      value4: "",
      value5: "",
      filters: {
        buyMode: 0,
        statusId: -1,
        date1: "",
        date2: "",
      },
      buyModes: [],
      statusoptions: [
        {
          Id: -1,
          Name: "全部"
        },
        {
          Id: 0,
          Name: "否"
        },
        {
          Id: 1,
          Name: "是"
        }
      ],
      iseditable: false,
      isclick: false,
      isclick1: true,
      isclick2: false,
      calssName: 0,
      timearr: [],
      countsarr: [],
      beginTime: "",
      endTime: "",
      beginTime1: "",
      endTime1: "",
      queryType: 0,
      pageIndex: 1,
      total: 0,
      goodList: [],
      value6: "",
      minRow: 0,
      maxRow: 0
    };
  },
  methods: {
    monthchange(val) {
      this.isclick = false;
      this.isclick1 = false;
      this.isclick2 = false;
      this.beginTime = val;
      if (
        this.beginTime != "" &&
        this.beginTime != null &&
        this.endTime != "" && this.endTime != null
      ) {
        this.queryType = 7;
        this.VIPStatitcs();
      }
      if (this.beginTime == null && this.endTime == null) {
        this.isclick = false;
        this.isclick1 = true;
        this.isclick2 = false;
        this.queryType = 4;
        this.VIPStatitcs();
      }
    },
    monthchange1(val) {
      this.isclick = false;
      this.isclick1 = false;
      this.isclick2 = false;
      this.endTime = val;
      if (
        this.beginTime != "" &&
        this.beginTime != null &&
        this.endTime != "" && this.endTime != null
      ) {
        this.queryType = 7;
        this.VIPStatitcs();
      }
      if (this.beginTime == null && this.endTime == null) {
        this.isclick = false;
        this.isclick1 = true;
        this.isclick2 = false;
        this.queryType = 4;
        this.VIPStatitcs();
      }
    },
    haldchange(val) {
      if (val) {
        this.isclick = false;
        this.isclick1 = false;
        this.isclick2 = false;
        this.queryType = 3;
        this.beginTime = val[0];
        this.endTime = val[1];
      } else {
        this.isclick = false;
        this.isclick1 = true;
        this.isclick2 = false;
        this.queryType = 0;
        this.beginTime = "";
        this.endTime = "";
      }
      this.VIPStatitcs();
    },
    // 调用 会员卡入会渠道统计接口
    getPieChart() {
      getVipBuyModeStatistics().then(data => {
        if (data.ResultCode == 1) {
          this.opinionData = data.ResultObj;
          let min = 0;
          let max = 0;
          this.opinionData.map(item => {
            if(item.value < min) {
              min = item.value;
            }
            if(item.value > max) {
              max = item.value;
            }
            this.minRow = min; // 饼图数据最小值
            this.maxRow = max; // 饼图数据最大值
          })
          this.$nextTick(function() {
            this.drawPie("pieReport");
          });
        }
      });
    },
    // 变形饼状图
    drawPie(id) {
      this.charts = this.echarts.init(document.getElementById(id));
      this.charts.setOption({
        tooltip : {
          trigger: 'item',
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        series: [
          {
            name: '查看占比',
            type: 'pie',
            radius: '88%',
            center: ['50%', '50%'],
            data:  this.opinionData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      });
    },
    // 入会记录列表
    getlist() {
      var obj = {
        userId: localStorage.Id,
        buyMode: this.filters.buyMode, // 入会方式
        isHaveTraded: this.filters.statusId, // 是否交易，0=否；1=是；查询全部传-1
        beginTime: this.filters.date1, // 注册时间开始时间
        endTime: this.filters.date2, // 注册时间结束
        pageIndex: this.pageIndex,
        pageSize: 10
      };
      getSelectVIPSalesRecordList(obj).then(data => {
        if (data.ResultCode == 1) {
          this.goodList = data.ResultObj;
          this.total = data.RowsCount;
        } else {
          this.goodList = [];
          this.total = 0;
        }
      });
    },
    // 点击查看消费记录
    endViews(scope) {
      this.embershipCardPrimaryKey = scope.row.Id; //	会员卡主键id
      this.userdId = scope.row.UserId; //	会员userId
      
      let ConsumptionId = scope.row.ConsumptionId; // 查询跳转id
      let QureySymbol = scope.row.QureySymbol; // 查询跳转标识，1=店铺订单； 2=代购单； 3=询价单
      let ConsumptionUserId = scope.row.ConsumptionUserId; // ConsumptionUserId
      if (QureySymbol == 0) {
        return
      }
      if (QureySymbol == 1) {
        var {href} = this.$router.resolve({path:'/transactionsPlatform',query:{consumptionUserId: ConsumptionUserId}}); // 店铺订单
      }
      if (QureySymbol == 2) {
        var {href} = this.$router.resolve({path:'/CustomerPurchaseOrder',query:{consumptionUserId: ConsumptionUserId}}); // 代购单
      }
      if (QureySymbol == 3) {
        var {href} = this.$router.resolve({path:'/LowPriceManagement',query:{ConsumptionUserId: ConsumptionUserId}}); // 询价单
      }
      window.open(href, '_blank');
    },
    findshop() {
      this.isclick = true;
      this.isclick1 = false;
      this.isclick2 = false;
      this.value6 = "";
      this.value4 = "";
      this.value5 = "";
      this.beginTime = "";
      this.endTime = "";
      if (this.calssName == 0) {
        this.queryType = 1;
      } else {
        this.queryType = 5;
      }
      this.VIPStatitcs();
    },
    findshop1() {
      this.isclick = false;
      this.isclick1 = true;
      this.isclick2 = false;
      this.value6 = "";
      this.value4 = "";
      this.value5 = "";
      this.beginTime = "";
      this.endTime = "";
      if (this.calssName == 0) {
        this.queryType = 0;
      } else {
        this.queryType = 4;
      }
      this.VIPStatitcs();
    },
    findshop2() {
      this.isclick = false;
      this.isclick1 = false;
      this.isclick2 = true;
      this.value6 = "";
      this.value4 = "";
      this.value5 = "";
      this.beginTime = "";
      this.endTime = "";
      if (this.calssName == 0) {
        this.queryType = 2;
      } else {
        this.queryType = 6;
      }
      this.VIPStatitcs();
    },
    find(val) {
      this.isclick = false;
      this.isclick1 = true;
      this.isclick2 = false;
      this.queryType = val;
      this.calssName = val;
      this.VIPStatitcs();
      this.value6 = "";
      this.value4 = "";
      this.value5 = "";
      this.beginTime = "";
      this.endTime = "";
    },
    // 导出
    onExport() {
      console.log("导出");
      var addParams = [
        { name: "userId", value: localStorage.Id },
        { name: "buyMode", value: this.filters.buyMode },
        { name: "isHaveTraded", value: this.filters.statusId },
        { name: "beginTime", value: this.filters.date1 },
        { name: "endTime", value: this.filters.date2 }
      ];
      var url = "/VIP/VIP/ExportExcelForVipSalesRecord";
      this.downLoad(url, addParams);
    },
    // 注册时间
    changetime() {
      if(this.value6+""=="null"){
        this.value6 = ["",""]
      }
      this.filters.date1 = this.value6[0];
      this.filters.date2 = this.value6[1];
    },
    // 查询入会方式
    getMembership(){
      var obj = {
        tableName:"tDCBuyVipCardModel",
        keyWord:"",
      }
      getkind(obj).then(data=>{
        if(data.ResultCode == 1){
          this.buyModes = data.ResultObj;
          this.buyModes.unshift({
            Id: 0,
            Name:"全部"
          })
        }
      })
    },
    // 查询
    onSubmit() {
      this.pageIndex = 1;
      this.getlist();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getlist();
    },
    VIPStatitcs() {
      var obj = {
        userId: localStorage.Id,
        queryType: this.queryType,
        beginTime: this.beginTime,
        endTime: this.endTime
      };
      SelectVIPStatitcs(obj).then(data => {
        if (data.ResultCode == 1) {
          this.timearr = [];
          this.countsarr = [];
          for (var i = 0; i < data.ResultObj.length; i++) {
            this.countsarr.push(data.ResultObj[i].Counts);
            this.timearr.push(data.ResultObj[i].Times);
          }
          var option = {
            backgroundColor: "#eee",
            title: {
              text: ""
            },
            tooltip: {
              trigger: "axis"
            },
            legend: {
              data: ["新增会员数"]
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true
            },
            toolbox: {
              feature: {
                saveAsImage: {}
              }
            },
            xAxis: {
              type: "category",
              boundaryGap: false,
              data: this.timearr
            },
            yAxis: {
              type: "value"
            },
            series: [
              {
                name: "新增会员数",
                type: "line",
                stack: "总量",
                data: this.countsarr
              }
            ]
          };
          var myChart=this.chart = this.echarts.init(document.getElementById("main"));
          myChart.setOption(option);
        }else{
        
           this.timearr = [];
          this.countsarr = [];

          var option = {
            backgroundColor: "#eee",
            title: {
              text: ""
            },
            tooltip: {
              trigger: "axis"
            },
            legend: {
              data: ["新增会员数"]
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true
            },
            toolbox: {
              feature: {
                saveAsImage: {}
              }
            },
            xAxis: {
              type: "category",
              boundaryGap: false,
              data: ""
            },
            yAxis: {
              type: "value"
            },
            series: [
              {
                name: "新增会员数",
                type: "line",
                stack: "总量",
                data:[]
              }
            ]
          };
          var myChart=this.chart = this.echarts.init(document.getElementById("main"));
          myChart.setOption(option);
        }
      });
    }
    // TradeConvert() {
    //   var obj = {
    //     userId: localStorage.Id,
    //     beginTime: this.beginTime1,
    //     endTime: this.endTime1
    //   };
    //   SelectVIPTradeConvert(obj).then(data => {
    //     this.obj.VIPTotalCounts = data.ResultObj.VIPTotalCounts;
    //     this.obj.VipNewCounts = data.ResultObj.VipNewCounts;
    //     this.obj = { ...this.obj };
    //     this.obj1.VIPTotalCounts = data.ResultObj.VipOrderTotalCounts;
    //     this.obj1.VipNewCounts = data.ResultObj.VipOrderCounts;
    //     this.obj1 = { ...this.obj1 };
    //     this.obj2.VIPTotalCounts = data.ResultObj.VipTotalPayCounts;
    //     this.obj2.VipNewCounts = data.ResultObj.VipFirstPayCounts;
    //     this.obj2 = { ...this.obj2 };
    //   });
    // }
  },
  mounted() {
    this.VIPStatitcs();
    // this.TradeConvert();
    this.getlist();
    this.__resizeHanlder = debounce(() => {
      if (this.chart) {
        this.chart.resize()
      }
    }, 100)
    this.getPieChart();
    this.getMembership();
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    window.removeEventListener('resize', this.__resizeHanlder)
    this.chart.dispose()
    this.chart = null
  },

};
</script>
<style scoped>
.el-input__inner {
  background-color: #fff;
  border: 1px solid #f2f2f2;
  cursor: pointer;
}
.gaikuang {
  font-size: 16px;
  font-weight: 600;

  padding: 10px;
  padding-left: 0px;
}
.findtj {
  padding: 5px;
  border: 1px dashed #ececec;
  margin-right: 29px;
}
.leftbut {
  display: inline-block;
  width: 70px;
  height: 33px;
  border-right: 1px solid #cfcfcf;
  text-align: center;
  line-height: 33px;
  cursor: pointer;
}
.footBtn {
  width: 40%;
  text-align: right;
}
.rightbut {
  display: inline-block;
  width: 70px;
  height: 25px;
  text-align: center;
  border: 1px solid #cfcfcf;
  line-height: 25px;
  cursor: pointer;
  border-radius: 5px;
}
/* 表格操作 */
.action_container {
  color: #677c9d;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// analysis.vue?1c9be41c